<!--
  Hidden rather than removed while an embedded child is open: the card holds `baseFormHost`, and destroying
  it would take the built controls and the user's unsaved edits with it. Keeping it alive behind the child is
  what makes the drill-down a detour rather than a restart.
-->
<mat-card appearance="outlined" class="dense-3" [class.base-entity-form-superseded]="hasActiveEmbeddedChild()">
  <mat-card-content>
    <form [formGroup]="baseEntityForm" (ngSubmit)="onSubmit()" (focusout)="onFieldBlur()">
      <ng-template baseFormHost></ng-template>
    </form>
    @if (violations().length > 0) {
      <ul class="rule-violations" data-testid="rule-violations">
        @for (violation of violations(); track violation.ruleId) {
          <li [class]="'rule-violation severity-' + violation.severity.toLowerCase()">
            <mat-icon>{{ violation.severity === 'ERROR' ? 'error' : violation.severity === 'WARNING' ? 'warning' : 'info' }}</mat-icon>
            <span>{{ violation.message ?? violation.error ?? violation.ruleId }}</span>
          </li>
        }
      </ul>
    }
  </mat-card-content>
  <mat-card-actions>
    <button id="cancel" [attr.data-testid]="entityDescriptor().createTestId('cancel')" mat-raised-button color="secondary" (click)="onCancel()">Cancel</button>
    <button id="delete" [attr.data-testid]="entityDescriptor().createTestId('delete')" mat-raised-button color="primary" type="button" [disabled]="isNewObject() || isAbstract() || entityReadOnly() || !rowDeletable()" (click)="onDelete()">Delete</button>
    @if (entityDescriptor().extraFormActionsTemplate?.(); as extraTpl) {
      <ng-container [ngTemplateOutlet]="extraTpl"></ng-container>
    }
    <button id="submit" [attr.data-testid]="entityDescriptor().createTestId('save')" mat-raised-button color="primary" type="submit" [disabled]="saveDisabled()" (click)="onSubmit()">Save</button>
  </mat-card-actions>
</mat-card>

<!-- Hosts an embedded child's screens, whose routes hang below this form's. -->
<router-outlet (activate)="hasActiveEmbeddedChild.set(true)" (deactivate)="hasActiveEmbeddedChild.set(false)" />
